import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'
import { defineCancelApiObject } from 'api/Utility/AxiosAbortController'
import filterSetFormattedResponses from 'api/ResponseFormats/Reporting/Overview/FilterSet'

const axiosCommonReq = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

export const filterSetEndpoints = {
  createFilterSet: async (params = {}) => {
    const signal = await cancelApiObject[
      'createFilterSet'
    ].handleRequestCancellation().signal
    return axiosCommonReq({ signal }).post(`/reporting/dashboard_filters`, {
      ...params,
    })
  },
  getFilterSet: async () => {
    const signal = await cancelApiObject[
      'getFilterSet'
    ].handleRequestCancellation().signal

    return axiosCommonReq({ signal }).get(`/reporting/dashboard_filters`)
  },
  showFilterSet: async (params: any) => {
    const signal = await cancelApiObject[
      'showFilterSet'
    ].handleRequestCancellation().signal

    return axiosCommonReq({ signal }).get(
      `/reporting/dashboard_filters/${params}`,
    )
  },
  updateFilterSet: async (params: any = {}) => {
    const signal = await cancelApiObject[
      'updateFilterSet'
    ].handleRequestCancellation().signal
    const { filterId, ...rest } = params
    return axiosCommonReq({ signal }).put(
      `/reporting/dashboard_filters/${filterId}`,
      {
        ...rest,
      },
    )
  },
  renameFilterSet: async (params: any = {}) => {
    return axiosCommonReq().patch(
      `/reporting/dashboard_filters/${params?.filterId}/rename`,
      {
        filter_name: params?.filterName,
      },
    )
  },
  deleteFilterSet: async (params: any = {}) =>
    axiosCommonReq().delete(`/reporting/dashboard_filters/${params}`),
}

const {
    createFilterSet,
    getFilterSet,
    showFilterSet,
    updateFilterSet,
    renameFilterSet,
    deleteFilterSet,
  } = filterSetEndpoints,
  cancelApiObject = defineCancelApiObject(filterSetEndpoints)

const filterSetApi = {
  createFilterSet: (params: any) =>
    apiWrapper({
      endPoint: createFilterSet,
      params,
      responseFormat: filterSetFormattedResponses.createFilterFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  getFilterSet: () =>
    apiWrapper({
      endPoint: getFilterSet,
      responseFormat: filterSetFormattedResponses.getFilterFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  showFilterSet: (params: any) =>
    apiWrapper({
      endPoint: showFilterSet,
      params,
      responseFormat: filterSetFormattedResponses.showFilterFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  updateFilterSet: (params: any) =>
    apiWrapper({
      endPoint: updateFilterSet,
      params,
      responseFormat: filterSetFormattedResponses.createFilterFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  renameFilterSet: (params: any) =>
    apiWrapper({
      endPoint: renameFilterSet,
      params,
      responseFormat: filterSetFormattedResponses.createFilterFormattedResponse,
      errorFailureAction: handleStatus500,
    }),
  deleteFilterSet: (params: any) =>
    apiWrapper({
      endPoint: deleteFilterSet,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default filterSetApi
